import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateTimeService {

  monthNames: Array<string> = [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre"
  ];

  daysOfWeekNames: Array<string> = [
    'Lunedi',
    'Martedi',
    'Mercoledi',
    'Giovedi',
    'Venerdi',
    'Sabato',
    'Domenica',
  ];

  // n Giorni dopo il quale scade l'annuncio
  expiresAfter: number = 60;

  constructor(
    private datePipe: DatePipe,
  ) { }

  // *** FORMATTING ***

  // Input: yyyy-MM-dd Output: ISO
  formatDateHasura(d?: string): string {
    if ( d ) {
      let date = new Date(d);
      date.setHours(23,59,59);
      return date.toISOString();
    }
    return '';
  }

  // Input: yyyy-MM-ddTHH:mm:ss Output: ISO
  formatDateTimeHasura(d?: string): string {
    if ( d ) {
      let date = new Date(d);
      return date.toISOString();
    }
    return '';
  }

  // Input: yyyy-MM-ddTHH:mm:ss.sssZ Output: yyyy-MM-ddTHH:mm:ss
  // Utilizzata per convertire le date di tipo timestamptz di Postgres/Hasura nel formato ISO per i datepicker datetime-local (orario locale)
  formatDateTimeFrontend(d: string): string {
    if ( d ) {
      let date = new Date(d);
      return this.datePipe.transform(date, "yyyy-MM-ddTHH:mm:ss") || '';
    }
    return d;
  }

  // Input: yyyy-MM-ddTHH:mm:ss.sssZ Output: yyyy-MM-dd
  // Utilizzata per convertire le date di tipo timestamptz di Postgres/Hasura nel dateonly per i datepicker date
  formatDateFrontend(d: string): string {
    if ( d ) {
      let date = new Date(d).toISOString();
      return date.split("T")[0];
    }
    return d;
  }

  // Input: qualsiasi stringa date Output: yyyy-MM-dd
  formatDateOnlyHasura(str: string): string {
    var d = new Date(str);
    return this.datePipe.transform(d, "yyyy-MM-dd") || '';
  }

  // Input: qualsiasi stringa date Output: dd/MM/yyyy HH:mm
  prettyPrintFullDate(str: string): string {
    var d = new Date(str),
    hours = '' + (d.getHours()),
    minutes = '' + (d.getMinutes()),
    // seconds = '' + (d.getSeconds()),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = '' + d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    if (minutes.length < 2)
      minutes = '0' + minutes;
    if (hours.length < 2)
      hours = '0' + hours;
    // if (seconds.length < 2)
    //   seconds = '0' + seconds;

    const date = [day, month, year].join('/');
    const time = [hours, minutes].join(':');
    return date + " " + time;
  }

  // Input: qualsiasi stringa date Output: dd/MM
  prettyPrintShortDate(date: Date): string {
    return date.getDate() + "/" + (date.getMonth() +1);
  }

  // Input: qualsiasi stringa date Output: HH:mm
  getTimeFromString(str: string): string {
    const dateObj = new Date(str);
    return this.datePipe.transform(str, "HH:mm") || '';
  }

  // Input: qualsiasi stringa date Output: dd/MM/yyyy
  getDateFromString(str: string): string {
    const dateObj = new Date(str);
    return this.datePipe.transform(str, "dd/MM/yyyy") || '';
  }

  // Input: qualsiasi stringa date Output: dd-MM-yyyy
  printBirthDate(dt: Date | string): string {
    if ( typeof dt === "string")
      dt = new Date(dt);
    return this.datePipe.transform(dt, "dd-MM-yyyy") || '';
  }


  // *** CALCS ***

  calcExpiresAt() {
    return this.addDays(new Date(), this.expiresAfter);
  }

  // Aggiunge algebricamente n giorni ad una data
  addDays(date: any, days: number): Date {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  addYears(date: any, years: number): Date {
    var result = new Date(date);
    result.setFullYear(result.getFullYear() + years);
    return result;
  }

  // Fa la differenza tra due date. Se la seconda data non è fornita, usa now()
  daysDifference(date1: string, date2?: string) {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const d1 = new Date(date1).getTime();
    const d2 = date2 ? new Date(date2).getTime() : new Date().getTime();
    const diffDays = Math.round((d1 - d2) / oneDay);
    return diffDays;
  }

  // TODO check
  getDateStringArrayByLength(length: number) {
    const day = new Date();

    let daysMonth = Array(length).fill("");
    daysMonth.forEach((item, index) => {
      daysMonth[index] = this.prettyPrintShortDate(day);
      day.setDate(day.getDate() -1);
    });

    return daysMonth.reverse();
  }

  // TODO check
  getMonthsStringArrayByLength(length: number) {
    const day = new Date();

    let months = Array(length).fill("");
    months.forEach((item, index) => {
      months[index] = this.monthNames[day.getMonth()];
      day.setMonth(day.getMonth() -1);
    });

    return months.reverse();
  }

  // TODO check
  getMonthsNumberArrayByLength(length: number) {
    const day = new Date();

    let months = Array(length).fill("");
    months.forEach((item, index) => {
      months[index] = day.getMonth();
      day.setMonth(day.getMonth() -1);
    });

    return months.reverse();
  }

  // *** GETTERS ***

  getDaysOfWeekNames(): Array<string> {
    return this.daysOfWeekNames;
  }

  getMonthsNames(): Array<string> {
    return this.monthNames;
  }

  getMonthName(date: Date) {
    return this.monthNames[date.getMonth()];
  }

  getFirstDayOfMonth(date: Date = new Date()): string {
    let d = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
    return d.toISOString();
  }

}
